import { Box, Card, Choicebox, Text } from '@ksyos/design-system';
import type { ISelectableOption } from '../../../interfaces/selectableOption';

export interface ISelectableOptionsCardProps {
    extraComponent?: JSX.Element | null;
    onChange: (id: string, sequence: number) => void;
    selectableOptions: ISelectableOption[];
    sequence: number;
    subtitle?: string;
    title: string;
}

export function SelectableOptionsCard(props: ISelectableOptionsCardProps) {
    return (
        <Card>
            <Card.Header title={props.title} />
            <Card.Body>
                {props.subtitle && (
                    <Text
                        color="minimal"
                        fontWeight="normal"
                        mb={2}
                        size="sm"
                    >
                        {props.subtitle}
                    </Text>
                )}
                <Box
                    display="flex"
                    flexDirection="row"
                    flexWrap="wrap"
                    gap={3}
                >
                    {props.selectableOptions.map((option) => (
                        <Choicebox
                            checked={option.selected}
                            id={option.id}
                            key={option.id}
                            label={option.displayName}
                            name={option.name}
                            onChange={() => props.onChange(option.id, props.sequence)}
                        />
                    ))}
                </Box>
                {props.extraComponent}
            </Card.Body>
        </Card>
    );
}
